import { Injectable } from '@angular/core';
import {
    HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse
} from '@angular/common/http';
import { retry, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Router } from '@angular/router';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(private router: Router) { }

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        return next.handle(req)
            .pipe(
                retry(1),
                catchError((error: HttpErrorResponse) => {
                    let errorMessage = '';
                    if (error.error instanceof ErrorEvent) {
                        // client-side error
                        errorMessage = `Error: ${error.error.message}`;
                        console.log(errorMessage, error);
                        this.router.navigate(['/error']);
                    }
                    // server-side error
                    else {
                        if (!error.status) {
                            this.router.navigate(['/error']);
                            return throwError(errorMessage);
                        }

                        errorMessage = `Error Status: ${error.status}\nMessage: ${error.message}`;
                        console.log(errorMessage, error);

                        switch (error.status) {
                            case 401:
                            case 403:
                                this.router.navigate(['/unauthorized']);
                                break;
                            case 404:
                                this.router.navigate(['/notfound']);
                                break;
                            case 500:
                            default:
                                this.router.navigate(['/error']);
                                break;
                        }

                    }
                    return throwError(errorMessage);
                })
            )
    }
}